import React from 'react';
import { useHistory } from 'react-router-dom';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { Button, formUtils } from '@insurancemenu/imenu-components-lib';
import { FormInstanceType } from 'types/formService';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import clsx from 'clsx';
import useImmutablePeriod from 'global/hooks/useImmutablePeriod';
import { WebFormCustomFields } from 'store/ui-stores/web-form/webFormStore';
import { CustomFormEntities } from '@insurancemenu/imenu-components-lib/dist/types';
import { createStyles } from './styles';

interface Props {
  formInstance: null | FormInstanceType;
  onCompleteForm: (e: React.FormEvent) => Promise<void>;
  onSaveAndExit: () => Promise<void>;
  dynamicForm: null | formUtils.DynamicFormController | formUtils.DynamicFormController<WebFormCustomFields>;
  loading: boolean;
  backBtnText: string;
  completeBtnText: string;
  completeBtnClass?: string;
  isFormCompleted?: boolean;
  periodId: string;
  customComponents?: CustomFormEntities;
}

const EnrollmentDynamicForm = observer((props: Props): JSX.Element => {
  const history = useHistory();
  const {
    exitModalStore: { openModal },
  } = useRootStore();

  const isPeriodNotEditable = useImmutablePeriod(props.periodId);

  const exitButtonFunc = props.isFormCompleted ? openModal : props.onSaveAndExit;

  const classes = createStyles();
  return (
    <form onSubmit={props.onCompleteForm}>
      <div className={clsx(classes.formBody, isPeriodNotEditable && classes.disableTableBody)}>
        <div className={classes.innerWrapper}>
          {props.formInstance?.form &&
            props.dynamicForm &&
            formUtils.renderSections(props.formInstance?.form, props.dynamicForm, props.customComponents)}
          <FormsSpinner display={props.loading} styles={classes.spinnerBg} />
        </div>
      </div>
      {!props.loading && (
        <footer className={classes.footer}>
          <Button
            type="outlined"
            size="large"
            width="24rem"
            onClick={isPeriodNotEditable ? history.goBack : exitButtonFunc}
            className={classes.saveButton}
          >
            {props.backBtnText}
          </Button>
          {!isPeriodNotEditable && (
            <Button
              size="large"
              color={props.dynamicForm?.areAllFieldsValid ? 'primary' : 'default'}
              width="24rem"
              htmlType="submit"
              disabled={!props.dynamicForm?.areAllFieldsValid}
              className={props?.completeBtnClass}
            >
              {props.completeBtnText}
            </Button>
          )}
        </footer>
      )}
    </form>
  );
});

export default EnrollmentDynamicForm;
